import {
    trigger,
    animate,
    transition,
    style,
    query,
    group
} from '@angular/animations';

export const fadeAnimation = trigger('fadeAnimation', [
    transition('* => *', [

        query(':enter, :leave', style({ position: 'fixed', width: '100%', opacity: '0' }), { optional: true }),
        group([
            query(':enter', [style({ transform: 'translateX(100%)', opacity: '0' }), animate('.4s ease-out', style({ transform: 'translateX(0%)', opacity: '1' }))], {
                optional: true,
            }),
            query(':leave', [style({ transform: 'translateX(0%)', opacity: '1' }), animate('.4s ease-out', style({ transform: 'translateX(-100%)', opacity: '0' }))], {
                optional: true,
            }),
        ])
    ])
]);

